// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2UjWT","bigColWidth":"Table_bigColWidth__1bow8","biggerColWidth":"Table_biggerColWidth__Xq_OP","row":"Table_row__3Yyxw","col":"Table_col__3c0dc"};